import { useEffect, useState } from "react";
import axios from "axios";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HomeIntro from "@/components/HomeIntro";
import HomeTeam from "@/components/HomeTeam";
import HomeChef from "@/components/HomeChef";
import HomeReservation from "@/components/HomeReservation";
import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import { resolveContent } from "@/lib/images";

const API = `${process.env.REACT_APP_BACKEND_URL || 'https://smapi.sanmartino26.al'}/api`;

const Home = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    document.title = "San Martino 26 — Trattoria Moderne · Tiranë";
    let cancelled = false;
    axios.get(`${API}/content`).then((res) => {
      if (!cancelled) setContent(resolveContent(res.data));
    }).catch(() => { });
    return () => { cancelled = true; };
  }, []);

  if (!content) {
    return (
      <div
        data-testid="home-loading"
        className="min-h-screen bg-transparent flex items-center justify-center"
      >
        <p className="text-[0.7rem] tracking-[0.32em] uppercase text-sm-olive animate-pulse">
          San Martino 26
        </p>
      </div>
    );
  }

  return (
    <main data-testid="home-page" className="bg-transparent text-sm-text">
      <Navigation brand={content.brand} />
      <Hero content={content.hero} />
      <HomeIntro content={content.intro} />
      <HomeTeam content={content.team} galleryImages={content.gallery?.images} />
      <HomeChef content={content.chef} />
      <Gallery content={content.gallery} />
      <HomeReservation />
      <Footer content={content.footer} />
      <FloatingButtons number={content?.brand?.whatsapp_number} />
    </main>
  );
};

export default Home;
